import script from "./RoleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleManagement.vue?vue&type=script&setup=true&lang=js"

import "./RoleManagement.vue?vue&type=style&index=0&id=70251a32&scoped=true&lang=css"

import exportComponent from "E:\\dipto_projects\\asset_tracker\\aqc-asset-tracker-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70251a32"]])

export default __exports__